import { format } from 'date-fns'
import { Factory } from 'fishery'
import { v4 as uuidv4 } from 'uuid'
import { type OpalApiComponent } from '@opallabs/api/v3'
import { safeDate } from '@opallabs/testing/src/dates'
import { decayingSample } from '@opallabs/testing/src/decayingSample'
import { longString } from '@opallabs/testing/src/strings'

type BlockDuplicationResourceV3 = OpalApiComponent<'V3', 'block_duplication'>

export const blockDuplicationFactory =
  Factory.define<BlockDuplicationResourceV3>(() => {
    return {
      id: uuidv4(),
      type: 'block_duplication',
      attributes: {
        created_at: format(safeDate, 'yyyy-MM-dd'),
        description: longString(),
        is_template: false,
        status: decayingSample([
          'completed',
          'processing',
          'pending',
          'failed',
        ])!,
        template_description: null,
        template_name: null,
        is_workspace_wide_template: false,
        title: longString(),
        updated_at: format(safeDate, 'yyyy-MM-dd'),
      },
    } satisfies BlockDuplicationResourceV3
  })
